export default __webpack_public_path__ + "static/media/Virgen_del_Pilar_sin_manto.0f8286e2.jpg";